import { Component, OnInit } from '@angular/core';
import { inductryMaster } from '../../../Models/InductryMasterModel';
import { NgForm, FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { AdminInductryMasterServices } from '../../../Services/Admin/InductryMaster';
import { CheckAuth } from '../../../Services/UtilityService';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { documentMaster } from '../../../Models/DocumentMasterModel';
import { AdminLoginComponent } from '../../admin/admin-login/admin-login.component';
import { FroalaEditorModule, FroalaViewModule } from 'angular-froala-wysiwyg';

@Component({
  selector: 'app-manage-master-document-add',
  templateUrl: './manage-master-document-add.component.html',
  styleUrls: ['./manage-master-document-add.component.css']
})
export class ManageMasterDocumentAddComponent implements OnInit {
  tokenKey: string = '';
  inductryMaster = new documentMaster();
  buttonText: string = '';
  userID: number;
  documentForm: FormGroup;
  public options: Object = {
    //imageUploadURL: config.endpoint + '/Admin/',
    imageUploadMethod: 'POST',
    imageAllowedTypes: ['jpeg', 'jpg', 'png'],
    serialNumber: "NobA-9F1rH-7A-31=="
  };

  constructor(private _fb: FormBuilder, private checkAuth: CheckAuth, private logincomp: AdminLoginComponent) {        
    this.tokenExpireCalculation(sessionStorage.getItem('appStartTime'), sessionStorage.getItem('tokenExpiryValue'));
    debugger;
    this.userID = +this.logincomp.GetplainText(sessionStorage.getItem('AdminUserId'));

    this.documentForm = this._fb.group({
      documentMasterId: 0,
      title: [''],
      topic: 0,
      type: 0,
      documentType: 0,
      description: [''],
      isRecommended: false,
      isUpdatedbyBLR: false,
      isDeleted: false,      
      createdBy: this.userID,
      createdDate: Date,
      modifiedBy: this.userID,
      modifiedDate: Date
    })
  }
  tokenExpireCalculation(startDate: string, tokenExpiry: string) {
    this.checkAuth.tokenExpireCalculation(startDate, tokenExpiry);
  }
  ngOnInit() {
    this.tokenKey = sessionStorage.getItem('tokenValue');
    this.buttonText = 'Save';
  }

}
